import { render, staticRenderFns } from "./StarSolidIcon.vue?vue&type=template&id=2b2b5f1e&"
import script from "./StarSolidIcon.vue?vue&type=script&lang=js&"
export * from "./StarSolidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports